export default {
  tabs: {
    profile: 'Profil',
    branding: 'Branding',
    domain: 'Domain',
    earning: 'Beteiligung',
    feature_flags: 'Feature-Flags',
    notification_channels: 'Benachrichtigungskanäle',
    pricing: 'Preise',
    fees: 'Gebühren',
    payments: 'Zahlungen',
    billing: 'Abrechnung',
  },
  earning: {
    internal_notice: 'Nur für FoodAmigos. Für den Partner nicht sichtbar.',
    read_only_notice: 'Nur Lesezugriff. Klicken Sie auf Bearbeiten, um Werte zu ändern.',
    editing_notice: 'Bearbeitung — Änderungen wirken sich auf echte Auszahlungsberechnungen aus.',
  },
  fees: {
    internal_notice:
      'Nur für FoodAmigos. Für den Partner nicht sichtbar, und nur Super-Admins können diesen Tab öffnen. Änderungen wirken sich darauf aus, was Gästen berechnet wird und was die Plattform verdient.',
    read_only_notice: 'Nur Lesezugriff. Klicken Sie auf Bearbeiten, um Werte in diesem Tab zu ändern.',
    editing_notice:
      'Bearbeitung — Speichern schreibt sowohl die Servicegebühr als auch die Verarbeitungssätze. Sätze gelten ab der nächsten Zahlung; frühere Transaktionen behalten die für sie erfasste Marge.',
  },
  profile: {
    read_only_notice: 'Nur Lesezugriff. Klicken Sie auf Bearbeiten, um Werte zu ändern.',
    editing_notice: 'Bearbeitung — der Anzeigename ist für Kunden sichtbar.',
    form: {
      name: {
        label: 'Partnername',
        hint: 'Der rechtliche / Firmenname. Wird intern und auf Abrechnungsdokumenten verwendet.',
      },
      display_name: {
        label: 'Anzeigename für Kunden',
        hint: 'Das „Powered by ___“-Label, das Kunden sehen. Entspricht standardmäßig dem Partnernamen.',
      },
      admin_email: {
        label: 'Admin-E-Mail',
        hint: 'Das eingeladene Admin-Konto. Kann hier nicht geändert werden — kontaktieren Sie Engineering, um das Konto umzuziehen.',
      },
      invoicing_emails: {
        label: 'Rechnungs-E-Mails',
        hint: 'Belege für Rechnungen an diesen Partner gehen an jede dieser Adressen. Leer lassen, um die Admin-E-Mail zu verwenden.',
        placeholder: 'Admin-E-Mail',
      },
      status: {
        label: 'Status',
        hint: 'Eingeladene Partner werden beim ersten Login aktiv — manuelles Aktivieren überspringt das. Sperren deaktiviert alle Logins des Partner-Teams.',
      },
      region: {
        label: 'Region',
        hint: 'Das Land ist fest. Wählen Sie einen Bundesstaat, wenn die Restaurants des Partners bundesstaatlichen Steuerregeln folgen — das ändert nur die Standardwerte des Partners, nicht bestehende Restaurants.',
      },
      messenger_audience: {
        label: 'Support-Chat',
        hint: 'Wer bei diesem Partner den FoodAmigos-Support-Chat erhält. FoodAmigos-Mitarbeiter haben ihn immer. White-Label-Partner betreuen ihre Restaurants selbst, daher erhalten ihn nur ihre Admins.',
        options: {
          everyone: 'Alle, einschließlich der Restaurants',
          partner_admins: 'Nur Partner-Admins',
          nobody: 'Niemand',
        },
      },
      shop_domains: {
        label: 'Shop-Domains',
        hint: 'Root-Domains, unter denen die Restaurant-Shops des Partners erreichbar sind. Die primäre Domain wird für neue Marken verwendet. Eigene Shop-Domains verbindet und trennt der Partner selbst; ihre DNS-Einträge stehen im Tab „Domain“.',
      },
    },
    region: {
      whole_country: 'Gesamtes Land',
    },
    shop_domains: {
      primary: 'Primär',
      platform_default: 'Plattform-Standard',
      empty: 'Noch keine Shop-Domain verknüpft',
    },
    statuses: {
      invited: 'Eingeladen',
      active: 'Aktiv',
      suspended: 'Gesperrt',
    },
    custody: {
      label: 'Zahlungsabwicklung',
      not_configured: 'Noch nicht konfiguriert',
      provider: 'Eigenes Gateway des Partners',
      platform: 'FoodAmigos wickelt Zahlungen ab',
      bank_account: {
        set: 'Bankkonto: {{label}} ({{status}})',
        missing: 'Noch kein Bankkonto. Der Partner hinterlegt es unter Partner-Abrechnung.',
        statuses: {
          active: 'aktiv',
          pending_verification: 'wird geprüft',
          action_needed: 'Handlungsbedarf',
          errored: 'Auszahlung fehlgeschlagen',
          missing: 'fehlt',
        },
      },
      hint: 'Wird durch die Zahlungskonfiguration im Tab „Zahlungen“ festgelegt und beim Speichern eines Zahlungswegs gesperrt. Bei Abwicklung über FoodAmigos wird die Umsatzbeteiligung des Partners monatlich ausgezahlt.',
      kyc: {
        label: 'Auszahlungskonto',
        missing: 'Noch nicht angelegt',
        incomplete: 'Verifizierung unvollständig',
        complete: 'Bereit für Auszahlungen',
        currently_due: 'Stripe benötigt noch: {{fields}}',
        send_link: 'Onboarding-Link senden',
        link_copied:
          'Onboarding-Link in die Zwischenablage kopiert — an den Partner weiterleiten. Er ist einmalig nutzbar und läuft ab.',
        link_ready: 'Onboarding-Link — an den Partner weiterleiten (einmalig nutzbar, läuft ab)',
        link_failed: 'Der Onboarding-Link konnte nicht erstellt werden.',
      },
    },
    suspend_confirm: {
      title: 'Diesen Partner sperren?',
      description:
        'Alle Teammitglieder des Partners werden deaktiviert und ihre Sitzungen beendet. Die Restaurants bleiben online.',
    },
  },
  branding: {
    read_only_notice: 'Nur Lesezugriff. Klicken Sie auf Bearbeiten, um Werte zu ändern.',
    editing_notice: 'Bearbeitung — Änderungen sind auf den White-Label-Oberflächen des Partners sichtbar.',
    upload: 'Logo hochladen',
    logo: {
      label: 'Logo',
      hint: 'Wird auf den White-Label-Oberflächen des Partners angezeigt.',
    },
    circle_logo: {
      label: 'Favicon / rundes Logo',
      hint: 'Quadratisches Logo für Favicon und Avatar. Optional — kann entfernt werden.',
    },
    splash_image: {
      label: 'Login-Bild',
      hint: 'Füllt die linke Hälfte der White-Label-Login-Seite des Partners randlos aus (formatfüllend zugeschnitten). Empfohlen: Hochformat, mindestens 1200×1200px. Optional — kann entfernt werden.',
    },
    footer_note: 'Weitere Branding-Optionen (Sekundärfarben) folgen später.',
  },
  revenue_split: {
    title: 'Umsatzbeteiligung',
    description:
      'Legen Sie den Anteil des Partners an jeder Gebühr fest, die FoodAmigos auf Bestellungen seiner Restaurants einnimmt. Standard ist 0% — FoodAmigos behält die volle Gebühr, bis ein Anteil gewährt wird. Auszahlung pro Abrechnungszyklus.',
    manage_on_fees: 'Im Gebühren-Tab verwalten',
    split: 'Partner {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Zahlungsgebühren',
      gift_card: 'Gutschein-Gebühr',
      delivery: 'Liefergebühren',
      service_fee: 'Servicegebühr',
    },
    notes: {
      service_fee:
        'Der Betrag, der Kunden berechnet wird, wird im Tab „Gebühren“ unter Servicegebühr-Einstellungen festgelegt.',
    },
  },
  service_fee_controls: {
    title: 'Servicegebühr-Einstellungen',
    description: 'Was der Partner seinen Kunden als Servicegebühr zusätzlich zur Bestellung berechnet.',
    zero_percentage_warning:
      'Ein Prozentsatz von 0% deaktiviert die Servicegebühr nicht: Berechnete Gebühren unterhalb des Mindestbetrags werden auf diesen aufgerundet, sodass jede Bestellung weiterhin mindestens den Mindestbetrag kostet.',
  },
  hard_limits: {
    title: 'Harte Limits',
    description:
      'FoodAmigos-Obergrenzen, durchgesetzt beim Speichern und beim Checkout. Keine Servicegebühr dieses Partners — einschließlich Restaurant-Überschreibungen — darf diese überschreiten.',
    max_percentage: {
      label: 'Maximaler Servicegebühr-%',
      help: 'Die Servicegebühr des Partners kann nicht darüber festgelegt werden. Plattform-Limit: 5%.',
    },
    min_amount: {
      label: 'Minimaler Servicegebühr-Betrag',
      help: 'Restaurant-Minimums können nicht unter diesen Betrag festgelegt werden.',
    },
    max_amount: {
      label: 'Maximaler Servicegebühr-Betrag',
      help: 'Absolute Obergrenze der festen Servicegebühr, unabhängig vom Prozentsatz.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Servicegebühr bei Tischbestellungen erheben',
      description:
        'Standard für die Restaurants dieses Partners; jedes kann es selbst festlegen. Aus: Tischbestellungen zahlen keine Servicegebühr.',
    },
    is_service_fee_change_allowed: {
      label: 'Ändern der Servicegebühr pro Restaurant erlauben',
      description: 'Erlaubt einzelnen Restaurants des Partners eine abweichende Servicegebühr.',
    },
    service_fee_platform_share: {
      label: 'Foodamigos-Anteil an der Servicegebühr',
    },
    recommended: 'Empfohlen: {{value}}',
    service_fee_percentage: {
      label: 'Standard-Servicegebühr-Prozentsatz',
      help: 'Gilt für jedes Restaurant des Partners, sofern nicht überschrieben.',
    },
    min_service_fee_amount: {
      label: 'Standard-Mindestgebühr-Betrag',
      help: 'Standard-Mindestbetrag pro Bestellung — niedrigere berechnete Gebühren werden aufgerundet. Restaurants können innerhalb der FoodAmigos-Limits einen eigenen Wert festlegen.',
    },
    max_service_fee_amount: {
      label: 'Standard-Maximalgebühr-Betrag',
      help: 'Standard-Obergrenze pro Bestellung — Restaurants können innerhalb der FoodAmigos-Limits einen eigenen Wert festlegen.',
    },
    primary_color: {
      label: 'Primäre Markenfarbe',
    },
    dashboard_subdomain: {
      label: 'Partner-Login-Kürzel',
      hint: 'Kleingeschriebener Slug — kennzeichnet das Branding des Partners im Login-Link für sein Team (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Login-Link für das Team',
      hint: 'Der Link, über den das Team des Partners seine gebrandete Login-Seite erreicht.',
    },
    file: {
      label: 'Bild',
    },
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  toasts: {
    load_error: 'Einstellungen konnten nicht geladen werden.',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
    logo_uploaded: 'Logo hochgeladen',
    logo_upload_failed: 'Logo konnte nicht hochgeladen werden',
    logo_removed: 'Logo entfernt',
    logo_remove_failed: 'Logo konnte nicht entfernt werden',
    file_too_large: 'Die Datei ist zu groß. Maximale Größe: {{max}} MB.',
    image_too_narrow: 'Das Login-Bild muss mindestens {{min}} px breit sein.',
  },
  notification_channels: {
    master_locked:
      'Der Master-Partner versendet für alle Restaurants der Plattform, daher können seine Kanäle hier nicht geändert werden.',
    unavailable: 'Benachrichtigungskanäle sind auf diesem Backend noch nicht verfügbar.',
    notice:
      'Interne Einstellung. Ein Partner ohne eigenes Twilio-Konto muss ausschließlich per E-Mail kommunizieren: Jede SMS, WhatsApp-Nachricht und jeder Anruf würde sonst über das Twilio-Konto von FoodAmigos laufen.',
    forbidden: 'Nur Super-Admins können Benachrichtigungskanäle ändern.',
    columns: {
      channel: 'Kanal',
      status: 'Aktiv',
    },
    channels: {
      email: {
        name: 'E-Mail',
        description: 'Immer aktiv, damit der Partner und seine Restaurants stets erreichbar sind.',
      },
      sms: {
        name: 'SMS',
        description: 'Bestellupdates und Anmeldecodes per SMS an Gäste.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Benachrichtigungen an Restaurantinhaber und Anmeldecodes an Gäste über WhatsApp.',
      },
      voice_call: {
        name: 'Anrufe',
        description: 'Erinnerungsanrufe bei offenen Bestellungen und die Telefonannahme.',
      },
      push: {
        name: 'Push-Benachrichtigungen',
        description:
          'Push-Benachrichtigungen an Gäste und an die Dashboard-App des Inhabers. Benachrichtigungen auf dem Personal-Tablet sind nicht betroffen.',
      },
    },
    toasts: {
      load_error: 'Die Benachrichtigungskanäle konnten nicht geladen werden.',
      error: 'Die Benachrichtigungskanäle konnten nicht gespeichert werden.',
      saved: 'Benachrichtigungskanäle gespeichert.',
    },
  },
  feature_flags: {
    internal_notice: 'Nur für FoodAmigos. Für den Partner nicht sichtbar. Änderungen wirken sofort.',
    read_only:
      'Nur lesend — eine Änderung der Restaurant-Abrechnung erfordert eine koordinierte Umstellung, keinen Schalter. Bitte an Engineering wenden.',
    forbidden: 'Partner-Feature-Flags können nur Super-Admins verwalten.',
    columns: {
      feature: 'Funktion',
      status: 'Status',
    },
    flags: {
      external_printer: {
        name: 'Externer Bondrucker',
        description:
          'Die Voreinstellung für Restaurants, die dieser Partner ab jetzt onboardet: Jedes neue Restaurant kann von Anfang an einen Netzwerk-Bondrucker mit der Bestellterminal-App verbinden. Bestehende Restaurants behalten die Einstellung aus ihrem eigenen Tab „Feature-Flags“, und jedes Restaurant lässt sich dort weiterhin einzeln umschalten.',
      },
      plg_onboarding: {
        name: 'Self-Service-Onboarding (PLG)',
        description:
          'Self-Service-Onboarding für Partner: gibt diesem Partner die geführte Seite „Neues Restaurant“ und den Onboarding-Assistenten anstelle des klassischen Dialogs „Unternehmen hinzufügen“ und der Erste-Schritte-Ansicht, blendet für den Partner und seine Restaurants Foodamigos-interne und noch nicht relevante Bereiche aus und sperrt das erste Live-Schalten, bis ein Starttermin vereinbart ist. Für jeden neuen Partner aktiv.',
      },
      issue_end_customer_receipts: {
        name: 'Kundenrechnungen',
        description:
          'Gäste können im Checkout eine Rechnung anfordern und per E-Mail erhalten. Für neue Partner deaktiviert, da die Rechnungsformate je Markt sehr aufwendig zu unterstützen sind.',
      },
      merchant_billing: {
        name: 'Restaurant-Abrechnung',
        description:
          'Die Restaurants des Partners werden über die Plattform abgerechnet. Deaktiviert bedeutet Abrechnung außerhalb der Plattform.',
      },
      cuisine_backfill: {
        name: 'Küchenarten-Nachtrag',
        description: 'Erlaubt den automatischen Nachtrag der Küchenarten für die Restaurants des Partners.',
      },
      image_backfill: {
        name: 'Bild-Nachtrag',
        description: 'Erlaubt den automatischen Nachtrag der Menübilder für die Restaurants des Partners.',
      },
      auto_image_generation: {
        name: 'Automatische Bilderzeugung',
        description: 'Erzeugt Menübilder bei Bedarf für die Restaurants des Partners.',
      },
      provider_billing: {
        name: 'Partnerabrechnung durch Foodamigos',
        description:
          'Nimmt diesen Partner in den Foodamigos-Abrechnungslauf auf. Deaktiviert bedeutet Abrechnung außerhalb der Plattform. Schaltet außerdem PayPal (direkt) für die Restaurants des Partners ein, inklusive Servicegebühr auf diese Zahlungen.',
      },
      partner_custom_dashboard_domain: {
        name: 'Eigene Dashboard-Domain',
        description:
          'Erlaubt diesem Partner, eine eigene Domain für das Dashboard zu verbinden, sodass sich sein Team und seine Restaurants unter der Adresse des Partners anmelden. Das Ein- oder Ausschalten ändert jeden Dashboard-Link, den die Plattform für diesen Partner versendet.',
      },
      partner_custom_shop_domain: {
        name: 'Eigene Shop-Domain',
        description:
          'Erlaubt diesem Partner, eine eigene Domain für die Online-Shops seiner Restaurants zu verbinden, unter der jedes Restaurant eine eigene Adresse erhält. Einzeln pro Partner freischalten: Es ändert die Adresse, die Kunden verwenden.',
      },
      partner_legal_documents: {
        name: 'Rechtstexte des Partners',
        description:
          'Erstellt Impressum, Datenschutzerklärung und AGB für die Shops der Restaurants dieses Partners aus den rechtlichen Angaben des jeweiligen Restaurants. Ausgeschaltet – oder solange die Angaben eines Restaurants unvollständig sind – zeigen die Shops die Standard-Rechtstexte der Plattform.',
      },
    },
    toasts: {
      load_error: 'Feature-Flags konnten nicht geladen werden',
      error: 'Feature-Flag konnte nicht geändert werden',
      enabled: 'Funktion aktiviert',
      disabled: 'Funktion deaktiviert',
    },
  },
};
